// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"SystemSettingsPage_contentWrapper__3Ox3j","column":"SystemSettingsPage_column__3exQz"};